import { NavBar } from 'components/NavBar/NavBar'
import { clearClientRole, getSingleClientRole, updateClientRole } from 'features/roles/clientRolesSlice'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  Flex,
  TabsContainer,
  Tabs,
  H1WithBack,
  PageWrapper,
  ContentWrapper,
} from 'styling/GlobalStyles'
import { InfoRolesTab } from './InfoRolesTab'
import { useNavigate, useParams } from 'react-router-dom'
import { AppDispatch, RootState } from 'store'
import { IRole } from 'types/roles.interface'
import { toast } from 'react-toastify'
import { PermissionsRolesTab } from './PermissionsRolesTab'
import { RoleWelfareTab } from './RoleWelfareTab'

export const EditRole = () => {
  const [active, setActive] = useState('Info')
  const { singleRole } = useSelector((store: RootState) => store.clientRoles)
  const dispatch = useDispatch<AppDispatch>()
  const navigate = useNavigate()
  const { id } = useParams()

  const [state, setState] = useState<IRole>({
    name: '',
    machineModels: [],
    operations: [],
    permissionPolicy: null,
    id: parseInt(id),
    permissions: {
      dashboard: false,
      aimVision: false,
      hr: false,
      fuel: false,
      machinery: false,
      inventory: false,
      analytics: false,
      resources: false,
      contractors: false,
    },
    freeDays: [],
    workScheduleModelId: null,
    shifts: [],
    shiftChangeType: null,
    shiftChangeInterval: 0,
    vacationDays: 0,
    logisticsInfo: {
      transportationAllowanceInCompanyAmount: 0,
      transportationAllowanceOutCompanyAmount: 0,
      transportationType: null,
      hasAccommodationAllowance: null,
      hasAccommodationProvided: null,
      hasExtraDutyAllowance: null,
      hasFoodAllowance: null,
      hasFoodProvided: null,
      hasResponsibilityAllowance: null,
      hasTransportationAllowance: null,
      accomodationAllowanceInCompanyAmount: 0,
      accomodationTierPolicy: null,
      accomodationAllowanceOutCompanyAmount: 0,
      foodAllowanceInCompanyAmount: 0,
      foodAllowanceOutCompanyAmount: 0,
      extraDutyAllowanceOutCompanyAmount: 0,
      extraDutyAllowanceInCompanyAmount: 0,
      responsibilityAllowanceInCompanyAmount: 0,
      responsibilityAllowanceOutCompanyAmount: 0,
    }
  })

  useEffect(() => {
    dispatch(getSingleClientRole(id))
    return () => {
      dispatch(clearClientRole())
    }
  }, [])


  useEffect(() => {
    if (singleRole) {
      setState({ ...singleRole })
    }
  }, [singleRole])

  const handleSubmit = async () => {
    if (!state.name.length) {
      toast.warn('Role name must be filled')
      return
    }

    const resp = await dispatch(updateClientRole(state))
    if (resp.meta.requestStatus === 'fulfilled') {
      navigate('/hr/roles')
    }
  }

  const renderTabs = () => {
    if (active === 'Info') {
      return <InfoRolesTab state={state} setState={setState} handleSubmit={handleSubmit} />
    } else if (active == 'Permissions') {
      return <PermissionsRolesTab state={state} setState={setState} handleSubmit={handleSubmit} />
    }
    return <RoleWelfareTab state={state} setState={setState} handleSubmit={handleSubmit} />
  }

  return (
    <div>
      <NavBar />
      <PageWrapper noFooter>
        <Flex between main>
          <H1WithBack mb='1.5' arrow title={'Edit ' + singleRole ? singleRole.name : ''} />
          <TabsContainer>
            <Tabs active={active === 'Info'} onClick={() => setActive('Info')}>
              Info
            </Tabs>
            <Tabs active={active === 'Welfare'} onClick={() => setActive('Welfare')}>
              Welfare
            </Tabs>
          </TabsContainer>
        </Flex>
        <ContentWrapper>{renderTabs()}</ContentWrapper>
      </PageWrapper>
    </div>
  )
}
